import {CompanyEntity, FileEntity, UserEntity} from "../../../proto/generated/api_entities_pb";
import {ICompany} from "./companyReducerTypes";
import {CompanyStatus} from "../../../utils/constans/statuses/companyStatuses";
import {UploadFile} from "antd/es/upload";

export const mapCompanyEntityToICompany = (item: CompanyEntity, userEntity?: UserEntity): ICompany => {
  const avatar = item.getAvatar()
  let avatarMapped: UploadFile | undefined;
  if (avatar?.getFileid()) {
    avatarMapped = {
      uid: avatar.getFileid(),
      name: avatar.getName(),
      fileName: avatar.getName(),
      url: avatar.getFilepath(),
    }
  }

  const operatorCard = item.getOperatorcard();
  let operatorCardMapped: UploadFile | undefined;
  if (operatorCard?.getFileid()) {
    operatorCardMapped = {
      uid: operatorCard.getFileid(),
      name: operatorCard.getName(),
      fileName: operatorCard.getName(),
      url: operatorCard.getFilepath(),
    }
  }

  const registrationCertificate = item.getRegistrationcertificate();
  let registrationCertificateMapped: UploadFile | undefined;
  if (registrationCertificate?.getFileid()) {
    registrationCertificateMapped = {
      uid: registrationCertificate.getFileid(),
      name: registrationCertificate.getName(),
      fileName: registrationCertificate.getName(),
      url: registrationCertificate.getFilepath(),
    }
  }

  const currency = item.getCurrency();
  
  // Map internationalFlightsEnabled and documents from UserEntity
  // If userEntity has getUserinternationalflight() set, then enabled = true, otherwise false
  const internationalFlightsEnabled = userEntity?.hasUserinternationalflight() || false;
  
  // Map international flight documents from UserInternationalFlightEntity
  let caaOperatorApprovalMapped: UploadFile | undefined;
  let easaTcoAuthorisationMapped: UploadFile | undefined;
  let faaAuthorizationMapped: UploadFile | undefined;
  
  const userInternationalFlight = userEntity?.getUserinternationalflight();
  if (userInternationalFlight) {
    const caaFile = userInternationalFlight.getCaaoperatorapprovalfile();
    if (caaFile?.getFileid()) {
      caaOperatorApprovalMapped = {
        uid: caaFile.getFileid(),
        name: caaFile.getName(),
        fileName: caaFile.getName(),
        url: caaFile.getFilepath(),
      };
    }
    
    const easaFile = userInternationalFlight.getEasatcoauthorizationfile();
    if (easaFile?.getFileid()) {
      easaTcoAuthorisationMapped = {
        uid: easaFile.getFileid(),
        name: easaFile.getName(),
        fileName: easaFile.getName(),
        url: easaFile.getFilepath(),
      };
    }
    
    const faaFile = userInternationalFlight.getFaaauthorizationfile();
    if (faaFile?.getFileid()) {
      faaAuthorizationMapped = {
        uid: faaFile.getFileid(),
        name: faaFile.getName(),
        fileName: faaFile.getName(),
        url: faaFile.getFilepath(),
      };
    }
  }

  return {
    id: item.getCompanyid(),
    name: item.getCompanyname(),
    companyStatus: item.getCompanystatusid() as CompanyStatus,
    type: item.getType(),
    phone: item.getPhone() && item.getPhone() !== 0 ? item.getPhone() : undefined,
    email: item.getEmail(),
    website: item.getWebsite(),
    description: item.getDescription(),
    address: item.getAddress(),
    avatar: avatarMapped,
    operatorCard: operatorCardMapped,
    registrationCertificate: registrationCertificateMapped,
    internationalFlightsEnabled,
    caaOperatorApproval: caaOperatorApprovalMapped,
    easaTcoAuthorisation: easaTcoAuthorisationMapped,
    faaAuthorization: faaAuthorizationMapped,
    currency: currency ? {
      id: currency.getCurrencyid(),
      name: currency.getName(),
    } : {
      id: 0,
      name: '',
    },
  }
}


export const mapICompanyToCompanyEntity = (item: ICompany): CompanyEntity => {
  const avatar = item.avatar;
  let avatarMapped: FileEntity | undefined;
  if (avatar && avatar.url) {
    avatarMapped = new FileEntity()
      .setFileid(avatar.uid)
      .setName(avatar.name)
      .setFilepath(avatar.url)
  }

  const operatorCard = item.operatorCard;
  let operatorCardMapped: FileEntity | undefined;
  if (operatorCard && operatorCard.url) {
    operatorCardMapped = new FileEntity()
      .setFileid(operatorCard.uid)
      .setName(operatorCard.name)
      .setFilepath(operatorCard.url)
  }

  const registrationCertificate = item.registrationCertificate;
  let registrationCertificateMapped: FileEntity | undefined;
  if (registrationCertificate && registrationCertificate.url) {
    registrationCertificateMapped = new FileEntity()
      .setFileid(registrationCertificate.uid)
      .setName(registrationCertificate.name)
      .setFilepath(registrationCertificate.url)
  }

  // International flights documents
  const caaOperatorApproval = item.caaOperatorApproval;
  let caaOperatorApprovalMapped: FileEntity | undefined;
  if (caaOperatorApproval && caaOperatorApproval.url) {
    caaOperatorApprovalMapped = new FileEntity()
      .setFileid(caaOperatorApproval.uid)
      .setName(caaOperatorApproval.name)
      .setFilepath(caaOperatorApproval.url)
  }

  const easaTcoAuthorisation = item.easaTcoAuthorisation;
  let easaTcoAuthorisationMapped: FileEntity | undefined;
  if (easaTcoAuthorisation && easaTcoAuthorisation.url) {
    easaTcoAuthorisationMapped = new FileEntity()
      .setFileid(easaTcoAuthorisation.uid)
      .setName(easaTcoAuthorisation.name)
      .setFilepath(easaTcoAuthorisation.url)
  }

  const faaAuthorization = item.faaAuthorization;
  let faaAuthorizationMapped: FileEntity | undefined;
  if (faaAuthorization && faaAuthorization.url) {
    faaAuthorizationMapped = new FileEntity()
      .setFileid(faaAuthorization.uid)
      .setName(faaAuthorization.name)
      .setFilepath(faaAuthorization.url)
  }

  const updatedCompany = new CompanyEntity()
    .setCompanyid(item.id)
    .setCompanyname(item.name)
    .setCompanystatusid(item.companyStatus)
    .setType(item.type);

  item.phone && updatedCompany.setPhone(item.phone);
  item.email && updatedCompany.setEmail(item.email);
  item.website && updatedCompany.setWebsite(item.website);
  item.description && updatedCompany.setDescription(item.description);
  item.address && updatedCompany.setAddress(item.address);
  avatarMapped && updatedCompany.setAvatar(avatarMapped);
  operatorCardMapped && updatedCompany.setOperatorcard(operatorCardMapped);
  registrationCertificateMapped && updatedCompany.setRegistrationcertificate(registrationCertificateMapped);

  return updatedCompany;
}
